(function ($, window) {
    "use strict";

    DSV.ui.pagination = {
        renderPagination: function (numberOfPages, currentPage, cssItemClass = "pagination__item", cssLinkClass = "pagination__link", dataAttribute = "data-page" ) {

            let paginationMarkup = document.createElement("ul" );
            paginationMarkup.className = "pagination";
            const pageRange = 2;

            const previous = `
                            <li class="${cssItemClass} ${cssItemClass}--prev" ${currentPage === 0 ? "disabled" : ""}>
                                <a class="${cssLinkClass}" href="#" ${currentPage === 0 ? "tabindex=\"-1\"" : ""} aria-label="Previous">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8">
                                        <path fill-rule="evenodd" d="M6.384 7.364l5.47-6.003a.508.508 0 0 0 0-.714.501.501 0 0 0-.71 0L6.004 6.29.859.647a.501.501 0 0 0-.71 0 .508.508 0 0 0 0 .714l5.47 6.003c.105.105.245.15.385.143a.498.498 0 0 0 .38-.143"/>
                                    </svg>
                                </a>
                            </li>
            `;

            const next = `
                            <li class="${cssItemClass} ${cssItemClass}--next" ${currentPage + 1 === numberOfPages ? "disabled" : ""}>
                                <a class="${cssLinkClass}" href="#" ${currentPage + 1 === numberOfPages ? "tabindex=\"-1\"" : ""} aria-label="Next">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8">
                                        <path fill-rule="evenodd" d="M6.384 7.364l5.47-6.003a.508.508 0 0 0 0-.714.501.501 0 0 0-.71 0L6.004 6.29.859.647a.501.501 0 0 0-.71 0 .508.508 0 0 0 0 .714l5.47 6.003c.105.105.245.15.385.143a.498.498 0 0 0 .38-.143"/>
                                    </svg>
                                </a>
                            </li>
            `;

            const ellipsis = `
                            <li class="${cssItemClass}" disabled>
                                <a class="${cssLinkClass}">
                                    ...
                                </a>
                            </li>
            `;

            let pages = [];
            let page;

            //add previous button
            pages.push(previous);


            //only display certain range
            let rangeStart = currentPage - pageRange + 1;
            let rangeEnd = currentPage + pageRange;

            if (rangeEnd > numberOfPages - 1) {
                rangeEnd = numberOfPages - 1;
                rangeStart = numberOfPages - pageRange * 2;
                rangeStart = rangeStart < 0 ? 0 : rangeStart;
            }

            if (rangeStart <= 0) {
                rangeStart = 0;
                rangeEnd = Math.min(pageRange * 2 - 1, numberOfPages - 1);
            }


            //ADD ellipsis in beginning
            if (rangeStart < pageRange) {
                for (let k = 0; k < rangeStart; k++) {
                    page =
                        `<li class="${cssItemClass} ${k === currentPage ? 'pagination__item--active' : ''}">
                            <a class="${cssLinkClass}" href="#" ${dataAttribute}="${k}">
                                ${k+1}
                                ${k === currentPage ? '<span class="sr-only">(current)</span>' : ""}
                            </a>
                        </li>`;

                    pages.push(page);
                }

            } else {
                page =
                    `<li class="${cssItemClass} ${0 === currentPage ? 'pagination__item--active' : ''}">
                            <a class="${cssLinkClass}" href="#" ${dataAttribute}="0">
                                1
                                ${0 === currentPage ? '<span class="sr-only">(current)</span>' : ""}
                            </a>
                        </li>
                    `;
                pages.push(page);
                pages.push(ellipsis);
            }

            //add numbered paging links
            for (let i = rangeStart, l = rangeEnd; i < l; i += 1) {

                page =
                        `<li class="${cssItemClass} ${i === currentPage ? 'pagination__item--active' : ''}">
                            <a class="${cssLinkClass}" href="#" ${dataAttribute}="${i}">
                                ${i+1}
                                ${i === currentPage ? '<span class="sr-only">(current)</span>' : ""}
                            </a>
                        </li>`;

                pages.push(page);
            }



            //ADD ellipsis in end
            if(rangeEnd > numberOfPages - pageRange) {
                for (let i = rangeEnd; i < numberOfPages; i++) {

                    page =
                        `<li class="${cssItemClass} ${i === currentPage ? 'pagination__item--active' : ''}">
                            <a class="${cssLinkClass}" href="#" ${dataAttribute}="${i}">
                                ${i+1}
                                ${i === currentPage ? '<span class="sr-only">(current)</span>' : ""}
                            </a>
                        </li>`;
                    pages.push(page);
                }
            } else {
                page =
                    `<li class="${cssItemClass}">
                        <a class="${cssLinkClass}" href="#" ${dataAttribute}="${numberOfPages - 1}">
                            ${numberOfPages}
                        </a>
                    </li>
                    `;
                pages.push(ellipsis);
                pages.push(page);
            }

            //add next button
            pages.push(next);

            paginationMarkup.innerHTML = pages.join("");
            return paginationMarkup;
        }
    }
})(jQuery, window);